import { StepperEfex } from '@efexteam/components';
import theme from '@efexteam/mui-theme';
import { Actions, Subjects, usePermission } from '@efexteam/permission-manager';
import { Box, Container, Grid, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import AddMemberStep from './components/addMember';
import AddMemberFormProvider from './components/addMemberFormProvider';
import AssignRoleStep from './components/assignRole';
import AddMemberConfirmation from './components/confirmation';
import ContinueBar from './components/continueBar/ContinueBar';
import Header from './components/header/Header';
import { ADD_TEAM_MEMBER_TABS_DATA, TABS } from './constants';
import useAddMember from './hooks/useAddMember';
import useTabsService from './hooks/useTabs';

const AddTeamMember = () => {
  const { t } = useTranslation();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const { handleClose } = useAddMember();
  const [canContinue, setCanContinue] = useState(true);
  const { can } = usePermission();
  const {
    activeTab,
    activeTabsArray,
    handleChange,
    setActiveTabsArray,
    goToActiveTab,
  } = useTabsService();

  if (!can(Actions.CREATE, Subjects.TEAM_MEMBERS)) {
    return <Navigate to="/dashboard" />;
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case TABS.ADD_MEMBER:
        return <AddMemberStep canContinue={setCanContinue} />;
      case TABS.ASSIGN_ROLE:
        return <AssignRoleStep canContinue={setCanContinue} />;
      case TABS.CONFIRM_MEMBER:
        return <AddMemberConfirmation />;
      default:
        return null;
    }
  };

  return (
    <AddMemberFormProvider>
      <Container maxWidth="xl" sx={{ minHeight: '100vh' }}>
        <Header onClose={handleClose} />
        <Box>
          <Grid container spacing={1} sx={{ flexGrow: 1 }}>
            <Grid item xs={12} sm={4} md={3}>
              {activeTab !== TABS.CONFIRM_MEMBER && (
                <StepperEfex
                  onStepChange={handleChange}
                  currentStep={activeTab}
                  steps={ADD_TEAM_MEMBER_TABS_DATA.map((step) => t(step))}
                  completedSteps={activeTabsArray}
                  isMobile={matches}
                  mobileVariant="progress"
                />
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Box>{renderTabContent()}</Box>
            </Grid>
          </Grid>
          <ContinueBar
            onCancel={handleClose}
            setActiveTabsArray={setActiveTabsArray}
            goToActiveTab={goToActiveTab}
            activeTabs={activeTabsArray}
            currentStep={activeTab}
            canContinue={canContinue}
          />
        </Box>
      </Container>
    </AddMemberFormProvider>
  );
};

export default AddTeamMember;
